import React, { useContext } from 'react';
import styled from 'styled-components';
import { LoadingIcon } from '../../../loading/LoadingIcon';
import { ShoppingCartContext } from '../../context/ShoppingCartContext';
import { AnimatePresence, motion } from 'framer-motion';
import { typography } from '../../../../theme';

const OverlayContainer = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const OverlayContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LoadingText = styled(typography.ParagraphMedium)`
  margin-top: 16px;
`;

export const OverlayLoading: React.FC = () => {
  const { isProcessingOrder } = useContext(ShoppingCartContext);

  if (!isProcessingOrder) return null;

  return (
    <AnimatePresence>
      <OverlayContainer>
        <motion.div
          key="address-book"
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          transition={{ duration: 0.4 }}
        >
          <OverlayContentContainer>
            <LoadingIcon />
            <LoadingText>Tilausta käsitellään...</LoadingText>
          </OverlayContentContainer>
        </motion.div>
      </OverlayContainer>
    </AnimatePresence>
  );
};
